module.exports = __webpack_public_path__ + "static/media/Logo1White.1cd9205f.png";